export enum InterviewState {
Active,
Complete,
}
